// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-templates-post-template-js": () => import("/opt/build/repo/src/templates/post-template.js" /* webpackChunkName: "component---src-templates-post-template-js" */),
  "component---src-pages-404-js": () => import("/opt/build/repo/src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("/opt/build/repo/src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-post-mdx": () => import("/opt/build/repo/src/pages/post.mdx" /* webpackChunkName: "component---src-pages-post-mdx" */)
}

